import SecureLS from "secure-ls";
import axios from "axios";
import { SalvarInformacoesDoClienteNoNavegador } from "./storage";

export function SalvarLoginDoClienteNoNavegador(cliente)
{
  let ls = new SecureLS();
  ls.set('login_cliente', {
    cliente: cliente
  });

  var dados_cliente = ls.get('dados_cliente');
  if (dados_cliente) {
    SalvarInformacoesDoClienteNoNavegador(cliente.nome, cliente.telefone, dados_cliente.cpf_nota, dados_cliente.cpf, dados_cliente);
  }else{
    SalvarInformacoesDoClienteNoNavegador(cliente.nome, cliente.telefone, "", "", "+55");
  }


}

export async function ObterClienteLogado()
{
  let ls = new SecureLS();
  let resultado = ls.get('login_cliente');
  if(resultado.cliente)
    return resultado.cliente;

  return null;
}

export async function Logout()
{
  let ls = new SecureLS();
  ls.remove('login_cliente');
}

export async function ChecarLogin(urlApi)
{
  let cliente = await ObterClienteLogado();
  if(cliente)
  {
    try {
      const {data:response} = await axios.post(urlApi + "cliente/login", {telefone: cliente.telefone}); // axios.get(urlApi+ "cliente/login/ping?token=" + cliente.token_de_autenticacao) //use data destructuring to get data from the promise object
      if(!response){
        await Logout();
      }
      return response;
    }catch (error) {
      console.log(error);
      await Logout();
      return false;
    }
  }else{
    await Logout();
    return false
  }
}



// WEBPACK FOOTER //
// ./src/services/auth.js